import React from "react";

export const BackButton = ({ onClick }) => (
  <button className="bbf-back" onClick={onClick}>
    ← Back
  </button>
);

export const NavLink = ({ onClick, children }) => (
  <button className="bbf-nav-link" onClick={onClick}>
    {children}
  </button>
);
